const locales = ['en', 'fr', 'de', 'es', 'pt', 'it']

export default locales
  .map(x => [x, require(`./translations/${x}.json`)])
  .reduce((acc, [name, module]) => Object.assign(acc, { [name]: module }), {})
